// Summerstar Tourist Parks booking strategy.
//
// A site's reserveUrl is the category's own page on summerstar.com.au
// (/caravan-parks/{park}/accommodation/{category}). The site keeps the stay
// and party in its server session (set by its own search form) and ignores
// dates in the URL, so the booking link is the category page as it is: the
// camper picks the dates in its booking panel, one Book Now from the cart.

export default {
  buildBookingUrl({ site }) {
    return site.reserveUrl;
  },

  // The park's accommodation list, every category it sells, is the
  // facility overview; the reserveUrl is one category's page.
  buildPreviewUrl(site) {
    const url = new URL(site.reserveUrl);
    url.search = "";
    url.pathname = url.pathname.replace(
      /\/accommodation\/[^/]+\/?$/,
      "/accommodation",
    );
    return url.toString();
  },

  describeBookingInputs() {
    return {
      inputs: {
        arrivalDate: {
          status: "ignored",
          notes:
            "The site takes dates only from its own session, never the URL.",
        },
        departureDate: {
          status: "ignored",
          notes:
            "The site takes dates only from its own session, never the URL.",
        },
        ref: {
          status: "ignored",
          notes: "site.reserveUrl already is the category's page.",
        },
        partySize: {
          status: "ignored",
          notes:
            "The site takes the party only from its own session, never the URL.",
        },
      },
    };
  },
};
